import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AllAttendanceReport from "../../pages/AllAttendanceReport/AllAttendanceReport";
import LoadingSuspense from "../../pages/LoadingSuspense";
import StudentInformationArchived from "../../pages/StudentInfomation/StudentInformationArchived";
import DetailInfoArchived from "../../pages/StudentInfomation/DetailInfoArchived";
import HistoricalAllAttendanceReport from "../../pages/AllAttendanceReport/HistoricalAllAttendanceReport";

const ManageStudentClassQrCode = lazy(() =>
  import(
    "../../components/ManageStudentClassComponents/ManageStudentClassQrCode"
  )
);
const ManageStudentClassTable = lazy(() =>
  import(
    "../../components/ManageStudentClassComponents/ManageStudentClassTable"
  )
);
const CreateSosReports = lazy(() =>
  import("../../components/SosReportsComponents/CreateSosReports")
);
const ClassManagement = lazy(() =>
  import("../../pages/ClassManagement/ClassManagement")
);
const CreateStudents = lazy(() =>
  import("../../pages/CreateStudent/CreateStudents")
);
const Homepage = lazy(() => import("../../pages/Homepage/Homepage"));
const Login = lazy(() => import("../../pages/Login/Login"));
const ManageStudentClass = lazy(() =>
  import("../../pages/ManageStudentClass/ManageStudentClass")
);
const SetPassword = lazy(() => import("../../pages/SetPassword/SetPassword"));
const Settings = lazy(() => import("../../pages/Settings/Settings"));
const SosReports = lazy(() => import("../../pages/SosReports/SosReports"));
const DetailInfo = lazy(() =>
  import("../../pages/StudentInfomation/DetailInfo")
);
const EditInfo = lazy(() => import("../../pages/StudentInfomation/EditInfo"));
const StudentInformation = lazy(() =>
  import("../../pages/StudentInfomation/StudentInformation")
);

const Router = () => {
  return (
    <Suspense fallback={<LoadingSuspense />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/create-password" element={<SetPassword />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/create-student" element={<CreateStudents />} />
        <Route path="/student-info" element={<StudentInformation />} />
        <Route path="/student-info/:id" element={<DetailInfo />} />
        <Route
          path="/student-info/archived"
          element={<StudentInformationArchived />}
        />
        <Route
          path="/student-info/archived/:id"
          element={<DetailInfoArchived />}
        />
        <Route path="/student-info/:id/edit" element={<EditInfo />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/class-management" element={<ClassManagement />} />

        <Route path="/manage-student-class" element={<ManageStudentClass />} />
        <Route
          path="/manage-student-class/class-list"
          element={<ManageStudentClassTable />}
        />
        <Route
          path="/manage-student-class/class-list/:id"
          element={<ManageStudentClassTable />}
        />
        <Route
          path="/manage-student-class/qr-codes"
          element={<ManageStudentClassQrCode />}
        />

        <Route path="/sos-reports" element={<SosReports />} />
        <Route path="/sos-reports/create-sos" element={<CreateSosReports />} />
        <Route
          path="/all-attendance-report"
          element={<AllAttendanceReport />}
        />
        <Route
          path="/all-attendance-report/historical"
          element={<HistoricalAllAttendanceReport />}
        />
      </Routes>
    </Suspense>
  );
};

export default Router;
